export function formatMoney(value: any, simboloMoeda = "R$") {
  const result = Intl.NumberFormat(`pt-BR`, {
    style: `currency`,
    currency: `BRL`,
  }).format(value || 0);

  return result.replace("R$", simboloMoeda);
}
